import { defaultApi } from '@/plugins/api/defaultApi'
import { or } from 'vuelidate/lib/validators'

const defaultHost = process.env.common?.myfinbiz?.host || 'nice-factoring.funda.kr'

export default {
  name: 'myfinbiz',
  namespaced: true,
  state: {
    organization: null,
  },
  getters: {
    isDefaultPlatform({ organization }) {
      if (!organization) {
        return true
      }
      return organization.host.includes(defaultHost)
    },
    platformName({ organization }) {
      return organization?.name || '번개입금'
    },
  },
  mutations: {
    setOrganization(state, organization) {
      state.organization = organization

    },
    getOrganization(state) {
      return state.organization;
    }
  },
  actions: {
    async init({ commit }, host) {
      if (host.startsWith('localhost')) {
        host = defaultHost
        // 테스트 하고싶은 host를 넣어야함
         host = 'jgpay.funda.kr'
      }
      try {
        const { data } = await defaultApi.getMyfinbizOrganizationsByHost(host)
        const [organization] = data
        let code = organization?.code
        const myfinbizOrganizationCode = localStorage.getItem('myfinbizOrganizationCode')
        if (myfinbizOrganizationCode) {
          code = myfinbizOrganizationCode
        }
        import(`@/assets/scss/myfinbiz/${code}.scss`)
        if (!organization.banks || organization.banks.length === 0) {
          organization.banks = [
            {
              bank: '88',
            },
          ]
        }

        commit('setOrganization', organization)
      } catch (e) {
        console.log(e)
      }
    },
    organizationsAddCustomer({ state }) {
      return defaultApi.postMyfinbizOrganizationsAddCustomer(state.organization.uuid)
    },
    async getCustomerFeeSettingsCurrent() {
      const { data } = await defaultApi.getMyfinbizCustomerFeeSettingsCurrent()
      return data
    },
    async getContractsAgreementsMyfinbizService() {
      const { data } = await defaultApi.getContractsAgreementsMyfinbizService()
      return data
    },
  },
}
